<!-- 右上角固定按钮 -->
<template>
  <div class="navBtn" :style="bgStyleObj">{{ text }}</div>
</template>

<script>
export default {
  props: {
    text: String,
    buttonImage: String
  },
  computed: {
    bgStyleObj() {
      if (this.buttonImage) {
        return {
          background: `center / contain url("${this.buttonImage}") no-repeat`
        };
      }
      return {};
    }
  }
};
</script>

<style lang="less" scoped>
.navBtn {
  margin-right: 24px;
  height: 44px;
  display: flex;
  align-items: center;
  line-height: normal;
  padding: 0 20px;
  font-size: 26px;
  color: #fff;
  background-color: rgba(51, 51, 51, 0.6);
  border-radius: 22px;
}
</style>
